import { render, staticRenderFns } from "./palylog.vue?vue&type=template&id=4adaec89&scoped=true&"
import script from "./palylog.vue?vue&type=script&lang=js&"
export * from "./palylog.vue?vue&type=script&lang=js&"
import style0 from "./palylog.vue?vue&type=style&index=0&id=4adaec89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adaec89",
  null
  
)

export default component.exports